/**
 * INPUT PARAMETERS
{
    onChangeFields: external function that handles changes in columns.
    selectItem: external function  // Replace standard behaviour select row and prevent any events like                                                 (footer.submit, edit). Incoming {ITEM} (selected object from table)
    add: external function,        // will appear 'ADD' button
    edit: external function,       // will appear 'EDIT' button if row selected
    download: external function,   // will appear icon "Download"
    upload: external function,     // will appear icon 'Upload'
    lastColumn: external function to show component it last column of each table row (takes all row data as a param and returns component)
    // groups: true,
    filter: external function,     // will appear 'search' input
    // save: this.save,
    // limitFields: ['type', 'lastEditDate'],
    handleSort: external function,
    total: external data on the general records number in response,
    t: external function for translating
    fields: {
        attach_id: {
            name: t('ID')
        },
        attach_type_id: {
            name: 'type',               // required! Name of column.
            classWidth: widths.min,     // required! number indicating the column width type (0..2)
            format: 'date',             // indicates if the original value should be changed to a different format ('string', 'number', 'date', 'translate')
            link: '/documents'          // link to be redirected after a click
            html: true,                 // flag indicating that the content should be output as html
            noSorted: true,             // flag for banning column sorting
            hidden: false,              // hiding flag
            permanent: true,            // flag for hiding columns
            value: data => data.id      // function that returns a value for a cell as a result of incoming data
            component: <p>{data}</p>    // component that will be inserted in the cell
        },
        ...
        tr: {
            dblClick: external function
        },
        footer: {                      // object, if footer exist render grid Footer Component
            submit: external function,
            cancel: external function
        },
        groups: {
            form: component with form,
            checkedItems: array of checked items,
            handleCheck: external function for sending checked items,
        }
    }
}
 **/

import React from "react";
import PropTypes from "prop-types";
import { isEqual } from "lodash";

import DataManager from "./DataManager";
import GridTable from "./GridTable";
import Header from "./Header";
import Footer from "./Footer";
import FormsWrapper from "./FormsWrapper";
import { getIdKey } from "./helpers";
import GridFloatingButton from "./GridFloatingButton";
import { withTranslation } from "react-i18next";
import DynamicFormPopup from "../DynamicFormPopup";

@withTranslation()
class Grid extends React.Component {
    constructor(props) {
        super(props);
        const { params, data, selected, preSelected } = props;
        const initialState = {
            data,
            selected,
            isAppealFormOpened: true,
            activeRowNum: null, // either row id or 'new'
            activeRowIndex: null,
            // activeRowIndex: null,
        };
        if (!params.sort || !params.sort.onChange) {
            initialState.sort = {};
        }
        this.state = initialState;

        this.gridRef = React.createRef(null);
    }

    componentWillReceiveProps(nextProps) {
        const { params, data, selected } = nextProps;
        // think about params sort issue and setState without condition
        if (selected) {
            this.setState({ data, selected });
        } else {
            this.setState({ data });
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.gridModIsCollapsed && this.props.gridModIsCollapsed) {
            // close grid mod popup if it was collapsed
            this.setState({ activeRowNum: null, activeRowIndex: null });
        }
    }

    toggleAppealForm = () => {
        this.setState(prevState => ({ isAppealFormOpened: !prevState.isAppealFormOpened }));
    };

    filter = (val, key) => {
        let add = false;

        for (let i in val) {
            if (!add && val.hasOwnProperty(i)) {
                add = add || (val[i] + "").includes(key);
            }
        }

        return add;
    };

    filterData = key => {
        const { data } = this.props;

        this.setState({ data: data.filter(val => this.filter(val, key)) });
    };

    // TODO functionality not used, refactor when needed
    filterFields = field => {
        console.error("function working not correct, need refactoring");
        // const { fields } = this.props.params;
        // let newFields = {};
        //
        // if (field !== 'all_fields') {
        //     for (let i in fields) {
        //         if (i === field) {
        //             newFields[i] = fields[i];
        //         }
        //     }
        // } else {
        //     newFields = this.props.params.fields;
        // }
        //
        // this.setState({ params: { ...this.state.params, fields: newFields } });
    };

    selectItem = item => {
        const { selected: prevSelected } = this.state;
        const { params, gridModFormKey, gridModDisabled } = this.props;

        if (!item || typeof item !== "object") {
            this.setState({
                selected: null,
                // activeRowNum: null,
                // activeRowIndex: null,
            });
            return;
        }

        const selected = { ...item };

        if (params.defaultId) {
            selected.id = item[getIdKey(params)];
        }

        if (selected.id || selected.id === 0) {
            if (params.selectItem) {
                params.selectItem(selected, prevSelected);
            }
            this.setState({ selected });
        }

        if (gridModFormKey && !gridModDisabled) {
            this.setState({
                activeRowNum: selected.id,
                activeRowIndex: selected.rowIndex,
            });
        }
    };

    handleSort = ({ field, order }) => {
        const {
            data,
            params: { sort },
        } = this.props;

        // if it's server side sorting
        if (sort && sort.onChange) return sort.onChange({ field, order });

        // if it's simple sorting
        return this.setState({
            data: data.sort((a, b) => {
                const direct = order === "desc" ? 1 : -1;
                return a[field] > b[field] ? direct : -direct;
            }),
            sort: { field, order },
        });
    };

    handleCheck = e => {
        const { value, checked } = e.target;
        const { checkedItems, handleCheck } = this.props.params.groups;
        const items = checked ? [...checkedItems, value] : checkedItems.filter(item => item !== value);

        handleCheck({ checkedItems: items });

        if (!checkedItems.length && items.length) {
            this.setState({ isAppealFormOpened: true });
        }
    };

    // scroll down in order to always show the popup window
    // removed since smart portal is improved
    handleGridModScroll = () => {
        if (this.gridRef && this.gridRef.current) {
            let yFound = false;
            let scrollYParent = this.gridRef.current.offsetParent;
            while (scrollYParent) {
                const styles = getComputedStyle(scrollYParent);
                const overflowY = styles.getPropertyValue("overflow-y");
                if (!yFound && overflowY && (overflowY.includes("auto") || overflowY.includes("scroll"))) {
                    yFound = true;
                    scrollYParent = scrollYParent;
                }
                if (yFound) {
                    break;
                }
                scrollYParent = scrollYParent.offsetParent;
            }
            if (scrollYParent) {
                const { bottom } = this.gridRef.current.getBoundingClientRect();
                if (scrollYParent.scrollTop < bottom) {
                    scrollYParent.scrollTop = bottom;
                }
            }
        }
    };

    handleGridModAddClick = () => {
        // const { gridModDynData } = this.props;
        this.setState({ activeRowNum: 0, activeRowIndex: 0, selected: null });
        // this.handleGridModScroll();
    };

    handleArrowUp = () => {
        const newIndex = this.state.activeRowIndex - 1;
        const selectedItem = this.props.data.find(item => item.rowIndex === newIndex);
        this.setState({ activeRowNum: selectedItem.id, activeRowIndex: newIndex });
        this.selectItem(selectedItem);
    };

    handleArrowDown = () => {
        const newIndex = this.state.activeRowIndex + 1;
        const selectedItem = this.props.data.find(item => item.rowIndex === newIndex);
        this.setState({ activeRowNum: selectedItem.id, activeRowIndex: newIndex });
        this.selectItem(selectedItem);
    };

    handleGridModDataChange = (type, index, values) => {
        if (type === "edit") {
            const newData = this.props.data.map(item => {
                if (item.id === index) {
                    const valuesKeys = Object.keys(values);
                    const { id, ...currentItemValues } = item;
                    const newValues = { id: item.id };
                    Object.keys(currentItemValues).forEach(itemKey => {
                        const key = valuesKeys.find(key => key.includes(itemKey));
                        newValues[itemKey] = values[key];
                    });
                    return newValues;
                }
                return item;
            });
            this.props.onGridModDataChange(newData);
        }
        if (type === "add") {
            const newItem = { id: index, ...values };
            const newData = [...this.props.data, newItem];
            this.props.onGridModDataChange(newData);
        }

        if (type === "delete") {
            const newData = this.props.data.filter(item => item.id !== index);
            this.props.onGridModDataChange(newData);
        }
    };

    render = () => {
        const { data, selected, isAppealFormOpened, sort: stateSort, activeRowNum, activeRowIndex } = this.state;
        const {
            params,
            toggleRowVisibility,
            onGridRefresh,
            onGridExport,
            onGridFloatingButtonClick,
            gridModLabel,
            gridModButtonText,
            gridModFormKey,
            getGridModRequestParams,
            gridModDynData,
            gridModPortalRepositionTrigger,
            gridModDelayedRepositionTrigger,
            gridModDelayedRepositionDelay,
            gridModDisabled,
            onGridModFormSave,
            onGridModFormDelete,
            getGridModConvertedWidgetValue,
            isGridMod,
            floatingButtonLeftOffset,
        } = this.props;

        let isGridFloatingButtonShow = false;
        if (typeof onGridFloatingButtonClick === "function") {
            isGridFloatingButtonShow = true;
        }

        if (
            onGridFloatingButtonClick &&
            onGridFloatingButtonClick.asyncHandler &&
            typeof onGridFloatingButtonClick.asyncHandler === "function"
        ) {
            isGridFloatingButtonShow = true;
        }

        let minArrowIndex = 0;
        let maxArrowIndex = 0;
        if (gridModFormKey) {
            //0 is a hack for avoiding NaN after adding new row when the last one was deleted and grid is empty
            minArrowIndex = data[0]?.rowIndex || 0;
            maxArrowIndex = data[data.length - 1]?.rowIndex || 0;
        }

        const maxRowNum = data[data.length - 1]?.id || 0;

        let gridModLabelSane = gridModLabel;
        if (gridModLabel === "*") {
            gridModLabelSane = "";
        }

        return (
            <>
                {gridModLabel && (
                    <div className="grid-mod__header">
                        <div className="grid-mod__header-label">{gridModLabelSane}</div>
                        {!gridModDisabled && (
                            <div className="grid-mod__header-button" onClick={this.handleGridModAddClick}>
                                + {gridModButtonText}
                            </div>
                        )}
                    </div>
                )}
                <div className="grid" ref={this.gridRef}>
                    <Header
                        params={params}
                        selected={selected}
                        filterData={this.filterData}
                        filterFields={this.filterFields}
                    />
                    <GridTable
                        params={params}
                        data={data}
                        selected={selected}
                        sort={{
                            ...stateSort,
                            ...params.sort,
                            handleSort: this.handleSort,
                        }}
                        selectItem={this.selectItem}
                        toggleRowVisibility={toggleRowVisibility}
                        {...(this.props.params.groups && {
                            groups: {
                                ...this.props.params.groups,
                                handleCheck: this.handleCheck,
                            },
                        })}
                        isGridMod={isGridMod}
                    />
                    <Footer
                        params={params}
                        selected={selected}
                        onGridRefresh={onGridRefresh}
                        onGridExport={onGridExport}
                    />

                    {this.props.params.groups && (
                        <FormsWrapper
                            {...this.props.params.groups}
                            filterOnlyCheckedItems={this.filterOnlyCheckedItems}
                            toggleAppealForm={this.toggleAppealForm}
                            isAppealFormOpened={isAppealFormOpened}
                        />
                    )}
                    {isGridFloatingButtonShow && (
                        <GridFloatingButton onGridFloatingButtonClick={onGridFloatingButtonClick} floatingButtonLeftOffset={floatingButtonLeftOffset} />
                    )}
                    {activeRowNum !== null && (
                        <DynamicFormPopup
                            formName={gridModFormKey}
                            requestParams={getGridModRequestParams && getGridModRequestParams(activeRowNum)}
                            targetElement={this.gridRef && this.gridRef.current}
                            staticDynData={
                                typeof gridModDynData === "function" ? gridModDynData(activeRowNum) : gridModDynData
                            } // gridModDynData is not used anymore, could be removed (used for mock purposes)
                            repositionTrigger={gridModPortalRepositionTrigger}
                            delayedRepositionTrigger={gridModDelayedRepositionTrigger}
                            delayedRepositionDelay={gridModDelayedRepositionDelay}
                            onClose={() => this.setState({ activeRowNum: null, activeRowIndex: null, selected: null })}
                            onArrowUp={this.handleArrowUp}
                            onArrowDown={this.handleArrowDown}
                            arrowIndex={activeRowIndex}
                            minArrowIndex={minArrowIndex}
                            maxArrowIndex={maxArrowIndex}
                            activeRowNum={activeRowNum}
                            maxRowNum={maxRowNum}
                            title={activeRowNum === 0 ? "gridMod.addNewRow" : "gridMod.editRow"}
                            onSave={onGridModFormSave}
                            onDelete={onGridModFormDelete}
                            onDataChange={this.handleGridModDataChange}
                            getConvertedWidgetValue={getGridModConvertedWidgetValue}
                            key={activeRowNum}
                            widgetsQuantity={params?.fields ? Object.keys(params?.fields).length : null}
                        />
                    )}
                </div>
            </>
        );
    };
}

Grid.propTypes = {
    data: PropTypes.array,
    params: PropTypes.object.isRequired,
    // from DataManager
    toggleRowVisibility: PropTypes.func,
};

export default DataManager(Grid);
